export default __webpack_public_path__ + "static/media/mke-zoo-bear-seal.468dce19.jpg";